module.exports = __webpack_public_path__ + "img/31.66b77e83.png";